export const Colors = {
  transparent: 'transparent',
  black: '#000000',
  white: '#ffffff',
  black_rgba: 'rgba(0, 0, 0, 0.54)',
  green100: '#61FFAA',
  green200: '#08490e',
  green300: '#38F892',
  yellow100: '#FACD35',
  error100: '#E64980',
  gray100: '#C7C7C7',
  gray200: '#353149',
  gray300: '#221E34',
  gray400: '#100D1E',
  gray500: '#1D1A2C',
};
